import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";
import DasboardLayout from "./dashboardLayout/dashboardLayout";

const Main = lazy(() => import("../components/Notification/main"));



const Notification = () => {
    return (
        <DasboardLayout 
            heading="Notifications"
        >
            <Suspense fallback={<CircularLoader/>}>
                <Main/>
            </Suspense>
        </DasboardLayout>
    )
}
export default Notification;